import React, { useState, useCallback, useRef, useEffect } from "react";
import QrScanner from "qr-scanner";
import {
  HttpLogin,
  HttpCheckToken,
  HttpPost,
  HttpGet,
} from "../../providers/HttpClient";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MenuBar from "../MenuBar/MenuBar";
import Alert from "../alertComponent/alertComponent";
import "./QRscanner.css";
import Axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import { set } from "react-datepicker/dist/date_utils";

const PatrolBarcodeComponent = () => {
  const scannerRef = useRef<QrScanner | null>(null);
  const [btnScan, setBtnScan] = useState(true);
  const [data, setData] = useState<any>({});
  const [visible, setVisible] = useState(false);
  let location: any = useLocation();
  let stopScan = false;
  const navigate = useNavigate();
  const locationId = useParams();
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState(false);
  const [isScanDone, setIsScanDone] = useState(false);
  const [isGetAddress, setIsGetAddress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [shiftName, setShiftName] = useState("");

  const closeAction = async () => {
    setOpen(false);
    navigate("/home");
  };

  const alert = (message, type, subMessage) => {
    setOpen(true);
    setAlertMessage(message);
    setAlertType(type);
    setShiftName(subMessage);
  };
  const scanNow = async (isScan: any) => {
    setBtnScan(isScan);
    setIsLoading(true);

    if (isScan === false) stopScan = true;

    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    await new Promise((r) => setTimeout(r, 3000));
    const videoElement: any = document.getElementById("scanView");
    // if (scannerRef.current) {
    //   scannerRef.current.stop();
    //   scannerRef.current.destroy();
    //   scannerRef.current = null;
    // }
    const scanner = new QrScanner(
      videoElement,
      async (result: any) => {
        // if (result.data != locationId.id) {
        //   alert("Lokasi yang dipilih tidak sesuai dengan barcode", false, "");
        //   return;
        // }
        // setTimeout(() => {
        scanner.stop();
        scanner.destroy();
        setIsScanDone(true);
        toast.success("Berhasil scan QR Code");
        navigate("/home/patrol/" + result.data);
        // }, 3000); // Add delay here
      },
      {
        onDecodeError: (error) => {},
        maxScansPerSecond: 1,
        highlightScanRegion: true,
        highlightCodeOutline: true,
        returnDetailedScanResult: true,
      }
    );
    try {
      await scanner.start();
    } catch (error) {
      console.error("Scanner gagal start:", error);
      //   alert(
      //     "Kamera tidak bisa diakses",
      //     false,
      //     "Pastikan kamera tidak digunakan aplikasi lain"
      //   );
      await scanner.destroy();
      return;
    }

    while (stopScan === false) await new Promise((r) => setTimeout(r, 3000));
    await scanner.stop();
    await scanner.destroy();
  };

  useEffect(() => {
    if (!isScanDone) {
      scanNow(true);
    } else {
      scanNow(false);
    }
  }, [isScanDone]);

  return (
    <>
      <div className="bg-main h-full mb-12">
        {/* <LoadingOverlay
          className="h-full"
          active={isLoading}
          spinner
          text="Loading..."
        > */}
        <Alert
          type={alertType}
          isOpen={open}
          closeAction={closeAction}
          message={alertMessage}
          subMessage={shiftName}
        />
        <div className="pb-28 ">
          <>
            <div hidden={isLoading == false}>
              <Skeleton
                containerClassName="qr-scanner-container"
                baseColor="#000000"
                highlightColor="#363434"
                className="qr-scanner-video"
                style={{ borderRadius: 12 }}
              />
            </div>
            <div hidden={isLoading == true} className="qr-scanner-container">
              <video
                id="scanView"
                // style={{ height: 500 }}
                className="qr-scanner-video"
              ></video>
            </div>
            <div className="flex justify-center mt-2 mb-10">
              <p>Scan QR Code untuk patroli</p>{" "}
            </div>{" "}
          </>
        </div>
        {/* </LoadingOverlay> */}

        {/* <MenuBar label={""}></MenuBar> */}
      </div>
    </>
  );
};
export default PatrolBarcodeComponent;
